import { render, staticRenderFns } from "./EmptyTip.vue?vue&type=template&id=7a32bbcc"
import script from "./EmptyTip.vue?vue&type=script&lang=js"
export * from "./EmptyTip.vue?vue&type=script&lang=js"
import style0 from "./EmptyTip.vue?vue&type=style&index=0&id=7a32bbcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports